module.exports = __webpack_public_path__ + "static/media/icon-video-camera-purple.25aa61e8.svg";